import sanitiseProps from '/shared/util/sanitiseProps';

import DropdownOption from '/shared/components/widgets/form/DropdownOption';

import StyledSelect from '/shared/styled/components/StyledSelect';
import StyledInputDropdown from '/shared/styled/components/StyledInputDropdown';

import StyledSelectWrapper from './__styled__/StyledSelectWrapper';
import StyledSelectLonelySelect from './__styled__/StyledSelectLonelySelect';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  dropdownItems?: { name: string; displayName: string; isPlaceholder?: boolean }[] | null;
  dropdownValue?: string;
  inputName?: string;
  placeholder?: string;
  testId?: string | null;
  isLoading?: boolean;
  onDropdownChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  $hasWhiteBackground?: boolean;
  $isErrored?: boolean;
  $highlight?: boolean;
  $dropdownSingleNoBorder?: boolean;
}

function Select(props: SelectProps) {
  const {
    children = null,
    dropdownItems = null,
    dropdownValue = '',
    disabled = false,
    testId = null,
    isLoading = false,
    onDropdownChange = () => {},
  } = props;

  if (Array.isArray(children)) {
    const availableChildren = children.filter(Boolean);

    if (availableChildren.length === 1 && !disabled) {
      return <StyledSelectLonelySelect>{availableChildren[0]}</StyledSelectLonelySelect>;
    }
  }

  const hasDropdown = Boolean(dropdownItems) && Array.isArray(dropdownItems);

  return (
    <StyledSelectWrapper $isLoading={isLoading}>
      <StyledSelect {...sanitiseProps(props)} data-test-id={testId} $hasDropdown={hasDropdown}>
        {children}
      </StyledSelect>
      {hasDropdown && (
        <StyledInputDropdown
          {...sanitiseProps(props)}
          data-test-id={`${testId}-dropdown`}
          value={dropdownValue}
          disabled={disabled}
          onChange={onDropdownChange}
        >
          {dropdownItems.map((dropdownItem) => (
            <DropdownOption key={dropdownItem.name} dropdownItem={dropdownItem} />
          ))}
        </StyledInputDropdown>
      )}
    </StyledSelectWrapper>
  );
}

export default Select;
